/* tslint:disable */
/* eslint-disable */
/**
 * Haltian IoT API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceInfo,
    DeviceInfoFromJSON,
    DeviceInfoFromJSONTyped,
    DeviceInfoToJSON,
} from './';

/**
 * Device object
 * @export
 * @interface Device
 */
export interface Device {
    /**
     * Haltian device ID
     * @type {string}
     * @memberof Device
     */
    id?: string;
    /**
     * Device name
     * @type {string}
     * @memberof Device
     */
    name?: string;
    /**
     * Deployment group ID
     * @type {string}
     * @memberof Device
     */
    deploymentGroupId?: string;
    /**
     * 
     * @type {DeviceInfo}
     * @memberof Device
     */
    deviceInfo?: DeviceInfo;
}

export function DeviceFromJSON(json: any): Device {
    return DeviceFromJSONTyped(json, false);
}

export function DeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Device {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'deploymentGroupId': !exists(json, 'deploymentGroupId') ? undefined : json['deploymentGroupId'],
        'deviceInfo': !exists(json, 'deviceInfo') ? undefined : DeviceInfoFromJSON(json['deviceInfo']),
    };
}

export function DeviceToJSON(value?: Device | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'deploymentGroupId': value.deploymentGroupId,
        'deviceInfo': DeviceInfoToJSON(value.deviceInfo),
    };
}


